import {css} from "@panda/css";

import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {OpenStreetMapsWithPoi} from "../../maps/components/map_with_poi/OpenStreetMapsWithPoi";
import {IPropertyDetailOffer} from "../../property/types/IPropertyDetailOffer";
import {ViewType} from "../../view_type/ViewType";

interface IProps {
    property: IPropertyDetailDTO;
}

export const HomematchTinderPropertyMap = (props: IProps) => {
    const {property} = props;

    const offer = property.offer;

    if (!offer.geo_point?.coordinates) {
        return null;
    }

    // The map reads only id, geo_point and region.country — the proxied KM
    // payload carries all three, so a narrow adapter stands in for the RP offer.
    const mapOffer = {
        id: offer.rp_id,
        geo_point: offer.geo_point,
        region: {country: property.region.country}
    } as unknown as IPropertyDetailOffer;

    return (
        <div className={mapHolderStyle}>
            <OpenStreetMapsWithPoi
                mapConfig={{scrollWheelZoom: false, fitBounds: true, fitBoundsDefaultZoom: 15, maxZoom: 18}}
                offer={mapOffer}
                viewType={ViewType.HOMEPAGE}
            />
        </div>
    );
};

const mapHolderStyle = css({
    height: "30rem",
    position: "relative",
    width: "100%",

    md: {
        height: "41.2rem"
    }
});
import {css} from "@panda/css";

import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {OpenStreetMapsWithPoi} from "../../maps/components/map_with_poi/OpenStreetMapsWithPoi";
import {IPropertyDetailOffer} from "../../property/types/IPropertyDetailOffer";
import {ViewType} from "../../view_type/ViewType";

interface IProps {
    property: IPropertyDetailDTO;
}

export const HomematchTinderPropertyMap = (props: IProps) => {
    const {property} = props;

    const offer = property.offer;

    if (!offer.geo_point?.coordinates) {
        return null;
    }

    // The map reads only id, geo_point and region.country — the proxied KM
    // payload carries all three, so a narrow adapter stands in for the RP offer.
    const mapOffer = {
        id: offer.rp_id,
        geo_point: offer.geo_point,
        region: {country: property.region.country}
    } as unknown as IPropertyDetailOffer;

    return (
        <div className={mapHolderStyle}>
            <OpenStreetMapsWithPoi
                mapConfig={{scrollWheelZoom: false, fitBounds: true, fitBoundsDefaultZoom: 15, maxZoom: 18}}
                offer={mapOffer}
                viewType={ViewType.HOMEPAGE}
            />
        </div>
    );
};

const mapHolderStyle = css({
    height: "30rem",
    position: "relative",
    width: "100%",

    md: {
        height: "41.2rem"
    }
});
